import $ from 'jquery';
import validationRules from '../../utils/validation';
import * as CONST from '../../utils/constants';
import Util from '../../utils/ui';
import FormTools from '../../utils/formTools';

class ContactUs {
	init() {
		this.bindEvents();
		this.initDropdown();
	}

	bindEvents() {
		this.contact_us = $('#contact-us');

		let inputList = $(this.contact_us).find('input');
		if (inputList.length > 0) {
			$(inputList).each((_, el) => {
				this.setDynamic(el);
			});
		}

		let textAreaList = $(this.contact_us).find('textarea');
		if (textAreaList.length > 0) {
			$(textAreaList).each((_, el) => {
				if ($(el).hasClass('required')) {
					this.setDynamic(el);
				}
			});
		}

		$('#submit').on('click', (e) => { this.checkContactUsForm(e); });
	}

	checkContactUsForm(e) {
		e.preventDefault();
		const key = $('.g-recaptcha-anchor').data('sitekey');
		let success = this.validateForm(this.contact_us);
		if (success) {
			grecaptcha.ready(() => {
				grecaptcha.execute(key, { action: 'submit' }).then((token) => {
					this.submitContactUs(token);
					this.contact_us[0].reset();

					$('#department').val('');
					$('#selected-option').text('Choose Department');
				});
			});
		} else {
			let firstError = $('.error:visible, .field-validation-error12:visible')[0];
			let t = $(firstError).offset().top;
			let offset = (Util.getViewPort() !== CONST.ViewPort.Desktop) ? 200 : 350;
			$('html, body').animate({
				scrollTop: (t - offset)
			}, 2000);
		}
	}

	submitContactUs(token) {
		let form = document.getElementById('contact-us');
		let formData = new FormData(form);

		let onResponse = (event) => {
			let currentScrollPosition = $(window).scrollTop();
			let thankYouMessage = $('#form-thank-you');
			let submitWrapper = $('.form-field.captcha');
			$(submitWrapper).addClass('hidden');
			$(thankYouMessage).removeClass('hidden');
		};

		if ($('#signupyes').prop('checked')) {
			formData.set('NewsletterSignUp', true);
		} else {
			formData.set('NewsletterSignUp', false);
		}
	
		formData.set('token', token);

		let object = {};
		formData.forEach((value, key) => { object[key] = value; });
		let json = JSON.stringify(object);
		let currentScrollPosition = $(window).scrollTop();
		let thankYouMessage = $('#form-thank-you');
		let submitWrapper = $('.form-field.captcha');
		$(submitWrapper).addClass('hidden');
		$(thankYouMessage).removeClass('hidden');

		$.ajaxSetup({
			headers: {
				'Content-type': 'application/json'
			}
		});
		$.post(form.action, json).done(onResponse);
	}

	setDynamic(el) {
		if ($(el).hasClass('email')) {
			this.emailSetup(el);
		} else if ($(el).hasClass('phone')) {
			this.phoneSetup(el);
		} else if ($(el).hasClass('required')) {
			$(el).blur(() => {
				validationRules.textValidate(el);
			});
		}
	}

	emailSetup(el) {
		if ($(el).hasClass('required')) {
			$(el).blur(() => {
				validationRules.emailValidate(el);
			});
		}
	}

	phoneSetup(el) {
		if ($(el).hasClass('required')) {
			$(el).blur(() => {
				validationRules.phoneValidate(el);
			});
		}
	}

	// Initialize custom dropdown
	initDropdown() {
		$('#dropdown-toggle').on('click', () => {
			$('#dropdown-menu').toggleClass('hidden');
			$('#custom-dropdown').toggleClass('focused');
		});

		$('#dropdown-menu li').on('click', (e) => {
			let selectedText = $(e.target).text();
			let selectedValue = $(e.target).attr('data-value');

			$('#selected-option').text(selectedText);
			$('#department').val(selectedValue);

			$('#dropdown-menu').addClass('hidden');
			$('#custom-dropdown').removeClass('focused');
			$('.dropdown.error').addClass('hidden');
		});

		$(document).on('click', (event) => {
			if (!$(event.target).closest('#custom-dropdown').length) {
				$('#dropdown-menu').addClass('hidden');
				$('#custom-dropdown').removeClass('focused');

				let selectedValue = $('#department').val();
				if (!selectedValue) {
					$('#custom-dropdown .error').removeClass('hidden');
				} else {
					$('#custom-dropdown .error').addClass('hidden');
				}
			}
		});
	}

	validateForm(form) {
		let errors = 0;

		// Validate input fields
		let inputList = $(form).find('input');
		if (inputList.length > 0) {
			$(inputList).each((_, el) => {
				if ($(el).hasClass('required')) {
					if ($(el).attr('type') === 'checkbox') {
						errors += validationRules.checkboxValidate(el) ? 0 : 1;
					} else if ($(el).attr('type') === 'radio') {
						errors += validationRules.radioValidate(el) ? 0 : 1;
					} else if ($(el).hasClass('zipcode')) {
						errors += validationRules.zipValidate(el) ? 0 : 1;
					} else if ($(el).hasClass('email')) {
						errors += validationRules.emailValidate(el) ? 0 : 1;
					} else if ($(el).hasClass('phone')) {
						errors += validationRules.phoneValidate(el) ? 0 : 1;
					} else {
						errors += validationRules.textValidate(el) ? 0 : 1;
					}
				}
			});
		}

		// Validate select fields (including custom dropdown)
		let selectList = $(form).find('select');
		if (selectList.length > 0) {
			$(selectList).each((_, el) => {
				if ($(el).hasClass('required')) {
					errors += validationRules.selectValidate(el) ? 0 : 1;
				}
			});
		}

		// Validate textarea fields
		let textAreaList = $(form).find('textarea');
		if (textAreaList.length > 0) {
			$(textAreaList).each((_, el) => {
				if ($(el).hasClass('required')) {
					errors += validationRules.textValidate(el) ? 0 : 1;
				}
			});
		}

		// **Validate custom dropdown** (If empty, add error)
		let selectedValue = $('#department').val();
		if (!selectedValue) {
			errors += 1;
			$('.dropdown.error').removeClass('hidden');
		} else {
			$('.dropdown.error').addClass('hidden');
		}

		return errors === 0;
	}
}

export default ContactUs;

$(() => {
	const contactUs = new ContactUs();
	contactUs.init();
});
